<template>
  <div class="sa-new-bookings sa-cursor">
    <span class="sa-date sa-h-sm-up" v-if="$route.path == '/appointments'">{{ data.time }}</span>
    <div class="sa-card-list-box">
      <figure class="sa-avt-img">
        <img :src="data.img || imgUrl" alt="patient" class="sa-img-cover" />
        <!-- <img src="unknownImg" alt="Doctor" class="sa-img-cover" /> -->
      </figure>
      <div class="sa-doct-det">
        <h6 class="sa-black-text">{{ data.pname || data.name }}</h6>
        <!-- <span class="sa-black-text">{{ data.product }} -</span> -->
        <span class="sa-gray-text">Appt ID : {{ data.apnt_id }}</span>
        <!-- <div class="sa-ins-apt">
                <span class="sa-refill">Refill</span>
                <span class="sa-bupa-str"><i class="icon-Insurance2"></i> Bupa Appointment</span>
              </div> -->
      </div>
      <div class="sa-loc-customer">
        <span class="sa-line-clamp"><i class="icon-location-line sa-black-text sa-mr5"></i>
        <a class="sa-link sa-gray-text" target="_black" :href="`http://maps.google.com/?q=${data.location}`">{{data.location }}</a></span>
        <span class="sa-black-text">Customer in: {{ data.customerDistance }}</span>
      </div>
    </div>
    <div class="sa-doct-apoint">
      <span class="sa-doct-apoint-time">
        <span class="sa-gray-text">
          <i class="icon-patient sa-secondary-text sa-mr5"></i>No.of patients:
          <span class="sa-black-text">{{ data.numberOfPatients }}</span>
        </span>
        <a class="sa-secondary-text" v-if="$route.path == '/appointments'"><span class="sa-link">Booking Details</span>
          <i class="icon-arrow-right sa-ml5"></i>
        </a>
      </span>
    </div>
    <div class="sa-d-f-sbetween sa-pt15">
      <span class="sa-date-text">{{ data.appointmentTime }}</span>
      <!-- <button class="sa-btn sa-btn-sm sa-btn-success" v-if="$route.path == '/appointments'">Start</button>
      <span class="sa-secondary-text" v-else><i class="icon-tick1 sa-light-green-text sa-mr5"></i>Started</span> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      imgUrl: 'https://img.litedev.com/images/unknown-avtar.png'
    }
  },
}
</script>